module.exports = __webpack_public_path__ + "img/USB-Wi-Fi.7aeffcaa.jpg";